import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-flex-direction-row is-justify-content-flex-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "itens-pagina" }, "Itens por Página", -1)
const _hoisted_3 = { class: "select is-small ml-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "mx-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angles-left" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angles-right" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

import { computed, ref, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PaginatorComp',
  props: {
    lista: {}
  },
  emits: ["paginate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

  const props = __props;
  const emit = __emit;
  __expose({ primeiraPagina });

  const itensPagina = ref(10);
  const paginaAtual = ref(0);
  const isPrimeiraPagina = computed(() => paginaAtual.value === 0);
  const isUltimaPagina = computed(() => {
    const qtdPaginas = Math.ceil(props.lista.length / itensPagina.value);
    return paginaAtual.value + 1 === qtdPaginas;
  });
  const indiceInicial = computed(() => paginaAtual.value * itensPagina.value);
  const indiceFinal = computed(() => {
    const ultimoCalculado = indiceInicial.value + itensPagina.value;
    if (props.lista.length < ultimoCalculado) {
      return props.lista.length;
    }

    return ultimoCalculado;
  });
  const ultimaPaginaPossivel = computed(() => arrayPaginado.length - 1);

  let arrayPaginado: [[]] = [[]];

  watch(props, () => {
    transformaArrayPaginado();
    primeiraPagina();
  });
  function transformaArrayPaginado() {
    arrayPaginado = [[]];
    let subArray: [] = [];
    for (let index = 0; index < props.lista.length; index++) {
      if (index !== 0 && index % itensPagina.value === 0) {
        if (arrayPaginado.length === 1) {
          arrayPaginado[0] = [...subArray];
        } else {
          arrayPaginado.push([...subArray]);
        }
        subArray = [];
      }
      subArray.push(props.lista[index]);
      if (index + 1 === props.lista.length) {
        if (!arrayPaginado[0].length) {
          arrayPaginado[0] = [...subArray];
        } else {
          arrayPaginado.push([...subArray]);
        }
      }
    }
  }

  function emitir() {
    emit('paginate', arrayPaginado[paginaAtual.value]);
  }

  function primeiraPagina() {
    paginaAtual.value = 0;
    emitir();
  }

  function proximaPagina() {
    paginaAtual.value++;
    emitir();
  }

  function paginaAnterior() {
    paginaAtual.value--;
    emitir();
  }

  function ultimaPagina() {
    paginaAtual.value = ultimaPaginaPossivel.value;
    emitir();
  }
  function mudouItensPorPagina() {
    transformaArrayPaginado();
    primeiraPagina();
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itensPagina).value = $event)),
        onChange: mudouItensPorPagina,
        name: "itens-pagina",
        id: "itens-pagina"
      }, [
        _hoisted_4,
        _createElementVNode("option", {
          value: 20,
          disabled: props.lista.length <= 10
        }, "20", 8, _hoisted_5),
        _createElementVNode("option", {
          vauel: 50,
          disabled: props.lista.length <= 20
        }, "50", 8, _hoisted_6)
      ], 544), [
        [_vModelSelect, itensPagina.value]
      ])
    ]),
    _createElementVNode("span", _hoisted_7, _toDisplayString(indiceInicial.value + 1) + " - " + _toDisplayString(indiceFinal.value) + " de " + _toDisplayString(props.lista.length), 1),
    _createElementVNode("button", {
      class: "button is-small has-text-grey",
      title: "Primeira Página",
      disabled: isPrimeiraPagina.value,
      onClick: primeiraPagina
    }, _hoisted_10, 8, _hoisted_8),
    _createElementVNode("button", {
      class: "button is-small has-text-grey",
      title: "Página Anterior",
      disabled: isPrimeiraPagina.value,
      onClick: paginaAnterior
    }, _hoisted_13, 8, _hoisted_11),
    _createElementVNode("button", {
      class: "button is-small has-text-grey",
      title: "Próxima Página",
      disabled: isUltimaPagina.value,
      onClick: proximaPagina
    }, _hoisted_16, 8, _hoisted_14),
    _createElementVNode("button", {
      class: "button is-small has-text-grey",
      title: "Última Página",
      disabled: isUltimaPagina.value,
      onClick: ultimaPagina
    }, _hoisted_19, 8, _hoisted_17)
  ]))
}
}

})